import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import ReactDOM from 'react-dom';
import BaseComponent from 'foundation/base-component';
import store from 'general/js/store';
import InfluenceBlock from './InfluenceBlock';

export default class InfluenceBlockComponent extends BaseComponent {

    constructor(...args) {
        super(...args);

        this.init();
    }


    init() {
        this.render();
    }

    onDestroy() {
        ReactDOM.unmountComponentAtNode(this.element);
    }

    render() {
        ReactDOM.render(

            <ReduxProvider store={store}>
                <InfluenceBlock
                    data={this.options} >
                </InfluenceBlock>
            </ReduxProvider>,
            this.element
        );
    }
}